import React, { useEffect, useRef } from 'react';

import { useSetDrawerState } from '@common/components/navigation-drawer/drawer-state-context';
import Iframe from './iframe';
import { useIframeLoadingState } from './hooks';
import IframeLoadingWrapper from './iframeLoadingWrapper';

const V2Iframe = ({
  iframeSrc,
  iframeRef,
  name,
  onLoadCallback = () => undefined,
  title
}) => {
  const setDrawerState = useSetDrawerState();
  const iframeRefInternal = useRef(null);

  iframeRef = iframeRef || iframeRefInternal; // eslint-disable-line
  const { isIframeLoaded } = useIframeLoadingState({ onLoadCallback, iframeRef });

  useEffect(() => {
    setDrawerState(false);
  }, []);

  return (
    <IframeLoadingWrapper isIframeLoaded={isIframeLoaded}>
      <Iframe name={name} title={title} iframeRef={iframeRef} src={iframeSrc} />
    </IframeLoadingWrapper>
  );
};

export default V2Iframe;
